export const MicrosoftMark = ({ className = '', testId = 'microsoft-logo' }) => (
  <div className={`flex items-center gap-2 sm:gap-3 ${className}`} data-testid={testId} aria-label="Microsoft">
    <svg viewBox="0 0 25 25" role="img" aria-label="Microsoft logo" className="h-6 w-6 flex-none sm:h-9 sm:w-9">
      <path d="M11.5216 0.5H0V11.9067H11.5216V0.5Z" fill="#f25022" />
      <path d="M24.2418 0.5H12.7202V11.9067H24.2418V0.5Z" fill="#7fba00" />
      <path d="M11.5216 13.0933H0V24.5H11.5216V13.0933Z" fill="#00a4ef" />
      <path d="M24.2418 13.0933H12.7202V24.5H24.2418V13.0933Z" fill="#ffb900" />
    </svg>
    <span className="text-base font-semibold leading-none tracking-normal text-[#f2f2f2] sm:text-[1.55rem]">Microsoft</span>
  </div>
);

export default MicrosoftMark;